import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { WishlistProvider } from "./context/WishlistContext";
import { CatalogProvider } from "./context/CatalogContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ShopperConcierge from "./components/ShopperConcierge";
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import DesignDetailPage from "./pages/DesignDetailPage";
import WishlistPage from "./pages/WishlistPage";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminPage from "./pages/AdminPage";
import StylePage from "./pages/StylePage";
import LimitedCollectionPage from "./pages/LimitedCollectionPage";

// Only mount the concierge on public shopper-facing routes — hide it on
// admin, auth, and password-reset flows where it would just be noise.
function ConciergeMount() {
  const { pathname } = useLocation();
  const hidden =
    pathname.startsWith("/admin") ||
    pathname.startsWith("/auth") ||
    pathname.startsWith("/forgot-password") ||
    pathname.startsWith("/reset-password");
  if (hidden) return null;
  return <ShopperConcierge />;
}

// The public storefront is browsable by anonymous visitors (Amazon-style).
// Only the /admin dashboard remains behind an auth gate.
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CatalogProvider>
            <WishlistProvider>
              <Routes>
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/" element={<Home />} />
                <Route path="/collections/:slug" element={<CategoryPage />} />
                <Route path="/collections/:slug/:sub" element={<CategoryPage />} />
                <Route path="/style/:styleSlug" element={<StylePage />} />
                <Route path="/limited/:id" element={<LimitedCollectionPage />} />
                <Route
                  path="/design/:catSlug/:subSlug/:number"
                  element={<DesignDetailPage />}
                />
                <Route path="/wishlist" element={<WishlistPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              <ConciergeMount />
            </WishlistProvider>
          </CatalogProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
